import React, { useEffect, useState } from 'react';

import { 
  DisablableOption, 
  UpsertableBase, 
  toDisablableOption
} from "@models";
import { DataType } from '@dndModels/Types';

import DandDAPI from '@dndUtilities/system_api';
import DataUtilities from '@dndUtilities/data_utilities';
import CommonUtilities from '@utilities/common_utilities';

import SelectStringBox from '@components/input/selects/SelectStringBox';

interface Props {
  name: string;
  value?: string;
  values?: string[];
  data_type?: DataType;
  data_types?: DataType[];
  option_objects?: UpsertableBase[];
  priority_extra_options?: (string | DisablableOption)[];
  extra_options?: (string | DisablableOption)[];
  filter?: any;
  filters?: any;
  limit?: number;
  extra_filter?: (o: UpsertableBase) => boolean;
  color?: string;
  multiple?: boolean;
  disabled?: boolean;
  auto_sort?: boolean;
  onChange: Function;
  display_format?: string;
  use_field?: string;
  max_selected?: number;
  log_it?: boolean;
}

interface ViewData { 
  data_type?: DataType;
  data_types: DataType[];
  option_objects: UpsertableBase[];
  priority_extra_options: (string | DisablableOption)[];
  extra_options: (string | DisablableOption)[];
  filter?: any;
  filters?: any; 
}

const api = DandDAPI.getInstance();
const data_util = DataUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

const parseData = ({ data_type,
  data_types,
  option_objects,
  priority_extra_options,
  extra_options,
  filter,
  filters 
}: ViewData): ViewData => {
  return { 
    data_type, 
    data_types: [...data_types], 
    option_objects: option_objects.map(o => o.clone(false)),
    priority_extra_options: [...priority_extra_options],
    extra_options: [...extra_options],
    filter: filter ? {...filter} : undefined,
    filters: filters ? {...filters} : undefined
  };
}

const dataMatches = (data1: ViewData, data2: ViewData) => {
  return common_util.objectsMatchLight(data1, data2);
}

const findMismatch = (data1: ViewData, data2: ViewData) => {
  return common_util.findMismatchLight(data1, data2);
}

export default function SelectObjectBoxSimple({ 
  name,
  value,
  values,
  data_type,
  data_types = [],
  priority_extra_options = [],
  option_objects = [],
  filter,
  filters,
  limit,
  extra_filter,
  color = "",
  multiple = false,
  disabled = false,
  auto_sort = false,
  extra_options = [],
  onChange,
  display_format,
  use_field,
  max_selected,
  log_it = false
}: Props) {
  const [options, setOptions] = useState<DisablableOption[]>([]); 
  const [my_extra_options, setExtraOptions] = useState<DisablableOption[]>([]);
  const [prev_data, setPrevData] = useState<ViewData>({ data_types: [], option_objects: [], priority_extra_options: [], extra_options: [] });

  useEffect(() => {
    const load = async () => {
      const data = parseData({ data_type, data_types, option_objects, priority_extra_options, extra_options, filter, filters });
      console.log(data);
      console.log(prev_data);
      if (!dataMatches(data, prev_data)) {
        console.log("loading");
        console.log(findMismatch(data, prev_data));
        setPrevData(data);
        if (log_it) {
          console.log(option_objects);
          console.log(extra_options);
          console.log(data_type);
          console.log(data_types);
          console.log(filter);
          console.log(filters);
        }
        let use_objects = option_objects;
        if (use_objects.length === 0) {
          if (data_type) {
            const dt = data_type;
            use_objects = await api.getObjects({ data_type: dt, filter });
          } else if (data_types.length > 0) {
            const res = await api.getSetOfObjects({
              data_types: data_types as DataType[],
              filter,
              filters
            });
            const dts = Object.keys(res);
            use_objects = dts.flatMap(dt => res[dt]);
          }
        }
        if (extra_filter) {
          use_objects = use_objects.filter(o => extra_filter(o));
        }
        const formatName = display_format ? (obj: UpsertableBase) => {
          return data_util.getStringWithReplacements3({ clean_me: display_format, obj });
        } : undefined;
        const new_options: DisablableOption[] = use_objects.map(obj => toDisablableOption({ obj, formatName, use_field }));
        setOptions(new_options);
        const new_extra_options = extra_options.map(obj => toDisablableOption({ obj }));
        setExtraOptions(new_extra_options);
      }
    }
    setTimeout(() => {
      load();
    })
  }, [option_objects, extra_options, data_type, data_types, filter, filters, log_it, prev_data]);

  if (limit && options.length > limit) {
    return <span>Too many results ({ options.length }, limit is { limit })</span>
  }
  return (
    <SelectStringBox
      name={name}
      value={value}
      values={values}
      options={options}
      extra_options={my_extra_options}
      color={color}
      multiple={multiple}
      disabled={disabled}
      onChange={onChange}
      auto_sort={auto_sort}
      max_selected={max_selected}
      // log_it
    />
  );
}
